import axios from "axios";

const COLOR_CACHE_KEY = "cached_colors";
const COLOR_CACHE_TIME_KEY = "cached_colors_time";
const CACHE_TTL = 1000 * 60 * 60; // 1 hour

// Helper: contrast color
export const getContrastColor = (hexColor) => {
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? "dark" : "light";
};

// Fetch colors with cache
export const fetchColors = async () => {
    try {
        // 1️⃣ Check cache
        const cached = localStorage.getItem(COLOR_CACHE_KEY);
        const cachedTime = localStorage.getItem(COLOR_CACHE_TIME_KEY);

        if (cached && cachedTime && Date.now() - cachedTime < CACHE_TTL) {
            return JSON.parse(cached);
        }

        // 2️⃣ Fetch from API
        const token = localStorage.getItem("token");
        const API_BASE_URL =
            process.env.REACT_APP_API_URL || "http://localhost:5000";

        const response = await axios.get(
            `${API_BASE_URL}/api/colors/active`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.data?.colors) {
            const colors = response.data.colors
                .filter((c) => c.isActive)
                .sort((a, b) => a.name.localeCompare(b.name));

            // 3️⃣ Save to cache
            localStorage.setItem(COLOR_CACHE_KEY, JSON.stringify(colors));
            localStorage.setItem(COLOR_CACHE_TIME_KEY, Date.now());

            return colors;
        }

        return [];
    } catch (error) {
        console.error("Error fetching colors:", error);
        return [];
    }
};
